<template>
    <div class="mak-kontrol-performansi">
        <v-banner class="subtitle-1">
            Müşteriler Kontroller Performansını buradan buradan takip edebilirsiniz
        </v-banner>

        <v-container fluid>
            <v-data-iterator
                :loading="loading"
                :items="items"
                :items-per-page.sync="itemsPerPage"
                :page.sync="page"
                :search="search"
                :sort-by="sortBy.toLowerCase()"
                :sort-desc="sortDesc"
                :disable-pagination="true"
                hide-default-footer
            >
                <template v-slot:header>
                    <v-toolbar
                        dark
                        color="deep-purple darken-3"
                        class="mb-1"
                    >
                        <v-text-field
                            v-model="search"
                            clearable
                            flat
                            solo-inverted
                            hide-details
                            prepend-inner-icon="mdi-magnify"
                            label="Musteri ara"
                        />
                        <template>
                            <v-spacer/>
                            <v-select
                                v-model="sortBy"
                                :items="fields"
                                item-text="label"
                                item-value="key"
                                prepend-inner-icon="mdi-sort"
                                label="Sırala"
                                class="mx-2"
                                flat
                                solo-inverted
                                hide-details
                            />
                            <v-spacer/>
                            <v-btn-toggle
                                v-model="sortDesc"
                                mandatory
                            >
                                <v-btn
                                    large
                                    depressed
                                    color="deep-purple"
                                    :value="false"
                                >
                                    <v-icon>mdi-arrow-up</v-icon>
                                </v-btn>
                                <v-btn
                                    large
                                    depressed
                                    color="deep-purple"
                                    :value="true"
                                >
                                    <v-icon>mdi-arrow-down</v-icon>
                                </v-btn>
                            </v-btn-toggle>
                        </template>
                    </v-toolbar>
                </template>

                <template v-slot:default="props">
                    <v-row class="my-6">
                        <v-col
                            v-for="item in props.items"
                            :key="item.name"
                            cols="12"
                            sm="6"
                            md="4"
                            lg="3"
                        >
                            <v-card>
                                <v-card-title class="subtitle-2 font-weight-medium text-truncate">
                                    {{ item.sirket_adi }}
                                </v-card-title>

                                <v-divider></v-divider>

                                <v-list dense>
                                    <v-list-item
                                        v-for="(key, index) in filteredKeys"
                                        :key="index"
                                        class="px-1"
                                    >
                                        <v-list-item-content
                                            :class="{ 'purple--text': sortBy === key }"
                                        >
                                            <v-list-item-title
                                                class="body-2"
                                                :class="{ 'purple--text': sortBy === key }"
                                            >
                                                {{ keysLabel[key] }}: {{
                                                    `${ (item[key.toLowerCase()] * 100).toFixed(0) }%`
                                                }}
                                            </v-list-item-title>
                                            <performans-gostergesi
                                                :field="fieldMap[key]"
                                                :control-count="controlCount"
                                                :kontroller="item.kontroller"
                                            />
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>

                                <v-card-actions>
                                    <v-btn
                                        color="deep-purple lighten-2"
                                        text
                                        @click="go(item.id)"
                                    >
                                        <v-icon left>mdi-account</v-icon>
                                        Profile git
                                        <v-icon right>mdi-arrow-right</v-icon>
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-col>
                    </v-row>
                </template>

                <template v-slot:footer>
                    <v-row
                        class="mx-6 my-4"
                        align="center"
                        justify="center"
                    >
                        <span class="grey--text">Sayfadaki kayıt sayısı</span>
                        <v-menu offset-y>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    dark
                                    text
                                    color="deep-purple accent-4"
                                    class="ml-2"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    {{ itemsPerPage }}
                                    <v-icon>mdi-chevron-down</v-icon>
                                </v-btn>
                            </template>
                            <v-list>
                                <v-list-item
                                    v-for="(number, index) in itemsPerPageArray"
                                    :key="index"
                                    @click="updateItemsPerPage(number)"
                                >
                                    <v-list-item-title>{{ number }}</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>

                        <v-spacer></v-spacer>

                        <span
                            class="mr-4 grey--text">
                            {{ numberOfPages }} sayfadan {{ page }}.si
                        </span>

                        <v-btn
                            fab
                            dark
                            color="deep-purple accent-4"
                            class="mr-1"
                            @click="formerPage"
                        >
                            <v-icon>mdi-chevron-left</v-icon>
                        </v-btn>
                        <v-btn
                            fab
                            dark
                            color="deep-purple accent-4"
                            class="ml-1"
                            @click="nextPage"
                        >
                            <v-icon>mdi-chevron-right</v-icon>
                        </v-btn>
                    </v-row>
                </template>
            </v-data-iterator>
        </v-container>
    </div>
</template>

<script>
    import moment from 'moment';
    import PerformansGostergesi from './PerformansGostergesi';
    import sonuc from './sonuc.json';

    export default {
        name: 'mak-kontrol-performansi',
        props: {
            loading: { type: Boolean },
        },
        components: { PerformansGostergesi },
        data () {
            return {
                itemsPerPageArray: [4, 6, 8, 12, 20],
                search: '',
                filter: {},
                sortDesc: false,
                page: 1,
                itemsPerPage: 6,
                sortBy: 'tahsilat_performansi',
                fields: [
                    { key: 'sirket_adi', label: 'Müşteri Adı', field: '' },
                    { key: 'tahsilat_performansi', label: 'Tahsilat', field: 'tahsilat_yapildi' },
                    { key: 'dolum_performansi', label: 'Dolum', field: 'dolum_yapildi' },
                ],
                data: [],
                controlCount: 12,
            }
        },
        computed: {
            queryParams() {
                return {
                    page: this.page,
                    itemsPerPage: this.itemsPerPage,
                    sortBy: this.sortBy,
                    sortDesc: this.sortDesc,
                    search: this.search,
                };
            },
            keys() {
                return this.fields.map(d => d.key);
            },
            keysLabel() {
                return this.fields.reduce((res, field) => (res[field.key] = field.label, res), {});
            },
            fieldMap() {
                return this.fields.reduce((res, field) => (res[field.key] = field.field, res), {});
            },
            numberOfPages () {
                return Math.ceil(this.items.length / this.itemsPerPage)
            },
            filteredKeys () {
                return this.keys.filter(key => key !== 'sirket_adi')
            },
            items() {
                return this.data
                    .map((d) => {
                        const dummy = new Array(this.controlCount) // create parallel control list with actual months
                            .fill(null)
                            .map((k, ind) => ({ month: moment().subtract(ind, 'months') }));

                        const kontroller = dummy.slice().map(({ month }) => {
                            const result = d.kontrol_gecmisi?.find(kg => moment(kg.kontrol_zamani).isSame(month, 'month'));
                            if (result) { // if there is control on the month, return it
                                return { ...result };
                            }
                            return {
                                kontrol_zamani: month.format('YYYY-MM-DD HH:mm:ss'),
                                tahsilat_yapildi: '0',
                                dolum_yapildi: '0',
                            }
                        });

                        const tahsilat_key = 'tahsilat_yapildi';
                        const tahsilat_performansi = this.extractPerformance(kontroller, tahsilat_key);
                        const dolum_key = 'dolum_yapildi';
                        const dolum_performansi = this.extractPerformance(kontroller, dolum_key);
                        return {
                            ...d,
                            kontroller,
                            tahsilat_key,
                            tahsilat_performansi,
                            dolum_key,
                            dolum_performansi,
                        }
                    });
            }
        },
        methods: {
            go(id) {
                this.$router.push({
                    name: 'musteri-bilgi',
                    params:  {
                        id,
                    },
                });
            },
            extractPerformance(array, key) {
                const doneCount = array.reduce((done, d) => {
                    if (d[key] === '1') {
                        done += 1;
                    }
                    return done;
                }, 0);
                return doneCount / this.controlCount;
            },
            nextPage () {
                if (this.page + 1 <= this.numberOfPages) this.page += 1
            },
            formerPage () {
                if (this.page - 1 >= 1) this.page -= 1
            },
            updateItemsPerPage (number) {
                this.itemsPerPage = number
            },
            getSonuc() {
                return new Promise(resolve => setTimeout(() => resolve(sonuc), 2000));
            },
            fetch() {
                this.$emit('update:loading', true);
                this.$requests.Musteri.getMusteriKontrolGecmisi()
                // this.getSonuc()
                    .then((data) => {
                        this.data = data;
                    })
                    .catch((error) => {
                        console.error('failed to fetch getMusteriKontrolGecmisi', error);
                    })
                    .finally(() => {
                        this.$emit('update:loading', false);
                    });
            }
        },
        created() {
            const {
                page,
                itemsPerPage,
                sortBy,
                sortDesc,
                search,
            } = this.$route.query;
            if (page) {
                this.page = Number(page);
            }
            if (itemsPerPage) {
                this.itemsPerPage = Number(itemsPerPage);
            }
            if (sortBy) {
                this.sortBy = sortBy;
            }
            if (sortDesc) {
                this.sortDesc = Boolean(sortDesc);
            }
            if (search) {
                this.search = search;
            }
        },
        mounted() {
            this.fetch();
        },
        watch: {
            queryParams() {
                this.$router.replace({
                    name: this.$route.name,
                    query: this.queryParams,
                });
            },
        }
    };
</script>

<style lang="scss">
    .mak-kontrol-performansi {
        .v-card__title {
            //white-space: nowrap;
            //overflow: hidden;
            //text-overflow: fade;
            //max-width: 95%;
        }
    }
</style>
